import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const ImagesWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  margin-top: 32px;

  ${QUERIES.tabletAndUp} {
    margin-top: 48px;
  }

  ${QUERIES.largeTabletAndUp} {
    margin-top: 72px;
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;
